import { motion } from "framer-motion";
import { PROCESS } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative bg-[#0B0F17] py-24 lg:py-36">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal><Eyebrow>Our Process</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl leading-[1.05] text-[#F5F0E6] sm:text-5xl lg:text-6xl">
              From slab <span className="italic text-[#CDA85B]">to</span> installation.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-[#C4C1B9]">
              One team handles every step, from the first measurement to the final polish. No hand-offs, no guesswork, and a schedule you can plan around.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div data-testid="process-turnaround" className="mt-10 inline-flex items-end gap-4 border-l-2 border-[#CDA85B] pl-5">
              <span className="font-display text-6xl leading-none text-[#F5F0E6]">5–10</span>
              <span className="pb-1 text-xs uppercase tracking-[0.18em] text-[#B8B4AA]">Business days<br />typical install after deposit</span>
            </div>
          </Reveal>
        </div>
      </div>

      <ol className="relative lg:col-span-7">
        <motion.span
          aria-hidden="true"
          className="absolute left-[27px] top-2 w-px origin-top bg-gradient-to-b from-[#CDA85B] to-[#CDA85B]/0 sm:left-[35px]"
          style={{ height: "calc(100% - 1rem)" }}
          initial={{ scaleY: 0 }}
          whileInView={{ scaleY: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        />
        {PROCESS.map((s, i) => (
          <Reveal as="li" key={s.n} delay={i * 0.08} className="group relative flex gap-6 pb-14 last:pb-0 sm:gap-10">
            <span className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full border border-[#CDA85B]/50 bg-[#0B0F17] font-display text-lg text-[#CDA85B] transition-colors duration-500 group-hover:bg-[#CDA85B] group-hover:text-[#0B0F17] sm:h-[72px] sm:w-[72px] sm:text-2xl">
              {s.n}
            </span>
            <div className="pt-2 sm:pt-4">
              <h3 className="font-display text-2xl text-[#F5F0E6] sm:text-3xl">{s.title}</h3>
              <p className="mt-3 max-w-lg text-[#C4C1B9]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
